import { Validator } from '@vista-digital/validator';
export const defaultOccPriceDisplayText = {
    itemPriceFormat: '${price}',
    discountedPriceFormat: 'Now ${price}',
    percentageOffDiscountFormat: '${discount}% off',
    priceOffDiscountFormat: 'Save ${discount}',
    freeDiscountLabel: 'Free',
    soldOutLabel: 'Sold out',
    availableFromTimeLabel: 'Available from ${nextAvailableAt|d|h:mm A}',
    availableFromDayLabel: 'Available from ${nextAvailableAt|d|dddd}',
    unavailableForShowtimeLabel: 'Not available for this showtime'
};
export const occPriceDisplayTextValidator = Validator.object({
    itemPriceFormat: Validator.nonEmptyString,
    discountedPriceFormat: Validator.nonEmptyString,
    percentageOffDiscountFormat: Validator.nonEmptyString,
    priceOffDiscountFormat: Validator.nonEmptyString,
    freeDiscountLabel: Validator.nonEmptyString,
    soldOutLabel: Validator.nonEmptyString,
    availableFromTimeLabel: Validator.nonEmptyString,
    availableFromDayLabel: Validator.nonEmptyString,
    unavailableForShowtimeLabel: Validator.nonEmptyString
});
//# sourceMappingURL=price.js.map